import styled from "styled-components";

export const MainContainer = styled.div`
  background-color: #ffffff;
  border-radius: 0.75rem;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  display: flex;
  padding: 1.5rem;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  gap: 1rem;
  align-items: center;
  overflow: hidden;

  &:hover {
    transform: scale(1.02);
  }
`;

export const TextContainer = styled.div`
  white-space: nowrap;
  text-overflow: ellipsis;
`;
